/**
 * Registry of all available artifact definitions
 */ export const artifactDefinitions = [];
/**
 * Register an artifact definition
 */ export function registerArtifact(definition) {
    const existingIndex = artifactDefinitions.findIndex((d)=>d.kind === definition.kind);
    if (existingIndex !== -1) {
        artifactDefinitions[existingIndex] = definition;
    } else {
        artifactDefinitions.push(definition);
    }
}
/**
 * Get an artifact definition by kind
 */ export function getArtifactDefinition(kind) {
    return artifactDefinitions.find((d)=>d.kind === kind);
}
/**
 * Clear all registered artifacts
 */ export function clearArtifactDefinitions() {
    artifactDefinitions.length = 0;
}
